<template>
  <div class="container" v-if="cart !== null">
    <section class="section">
      <h2>Shopping Cart</h2>
    </section>
    <section class="section" v-if="!loading">
      <cart-item v-for="item in cart" :item="item" :key="item.id"></cart-item>
      <div class="columns">
        <div class="column is-12 has-text-right">
          <!-- <p>Subtotal: ${{ (subtotal / 100).toFixed(2) }}</p> -->
          <!-- <p>Tax: ${{ (tax / 100).toFixed(2) }}</p> -->
          <p>Total: <b>${{ (subtotal / 100).toFixed(2) }}</b></p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12 has-text-right">
          <button class="button is-large" @click="$router.push('/checkout')" id="checkout-button" :disabled='isCheckoutDisabled' >Checkout</button>
        </div>
      </div>
    </section>
    <loader v-else></loader>
  </div>
  <loader v-else></loader>
</template>

<script>
import Loader from './Loader';
import BInput from 'buefy/src/components/input/Input';
import CartItem from './CartItem';

export default {
  components: {
    CartItem,
    BInput,
    Loader,
  },

  name: 'cart',

  watch: {
    cart() {
      if (this.cart === null || this.cart.length === 0) {
        this.$router.replace('/');
      }
    },
  },

  mounted() {
    if (this.cart === null || this.cart.length === 0) {
      this.$router.replace('/');
    }
    // cartLoadMe();
  },

  computed: {
    cart() {
      return this.$store.state.cart.cart;
    },

    loading() {
      return this.$store.state.cart.loading;
    },

    subtotal() {
      let tt = 0;

      this.cart.forEach((item) => {
        tt += item.price * item.quantity;
      });

      return tt;
    },

    tax() {
      return this.subtotal * 0.13;
    },

    total() {
      return this.subtotal + this.tax;
    },

    isCheckoutDisabled: function() {
      return false;
      /*
      let dateNow = new Date();
      let dayToday = dateNow.getDay()
      return (dayToday == 0);
      */
    },

  },
};


function cartLoadMe() {
  let dateNow = new Date();
  let dayToday = dateNow.getDay()
    
  if (dayToday == 0) { // sunday
    document.getElementById('no-sunday-store').style.display = 'block';
  }

}


</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Cart.vue